/* tslint:disable:max-line-length */
import React from 'react';
import { IconTypeProps } from '../types';
import classNames from 'classnames';

export const LandingPageIcon = ({
  className,
  style,
  color = '#938BB7',
  onClick,
}: IconTypeProps) => {
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      width="16"
      height="17"
      fill="none"
      style={style}
    >
      <g clipPath="url(#clip0)" fill={color}>
        <path d="M15.29 13.411a2.01 2.01 0 00-1.427-.6h-1.808V1.036a.317.317 0 00-.317-.316H.473a.317.317 0 00-.317.316v7.176a.317.317 0 00.633 0v-6.86h10.632v12.556c0 .878.356 1.663.911 2.179H2.628c-1.014 0-1.839-.978-1.839-2.179v-3.174a.317.317 0 10-.633 0v3.174c0 1.55 1.11 2.812 2.472 2.812h11.265c.515 0 1-.199 1.368-.56a1.942 1.942 0 00.029-2.748zm-1.397 2.675c-1.014 0-1.838-.977-1.838-2.179v-.462h1.808c.37 0 .716.145.974.41.25.253.383.587.376.937a1.327 1.327 0 01-1.32 1.294z" />
        <path d="M2.308 9.437h4.171a.317.317 0 000-.633H2.308a.317.317 0 000 .633zM9.873 10.282H2.308a.317.317 0 000 .633h7.565a.317.317 0 000-.633zM10.19 12.076a.317.317 0 00-.317-.316H2.308a.317.317 0 100 .633h7.565a.317.317 0 00.317-.317zM2.308 13.238a.317.317 0 100 .633h4.171a.317.317 0 100-.633H2.308zM7.776 9.439a.317.317 0 00.293-.435L8.068 9a.317.317 0 10-.588.237l.002.004c.05.123.169.198.294.198zM.181 9.604a.317.317 0 10.587-.238L.766 9.36A.316.316 0 10.18 9.6l.001.004z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.455 2.465H1.799v5.042h8.656V2.465zm-7.788.952h4v3.11h-4v-3.11zm4.897.917h1.498a.317.317 0 000-.633H7.564a.317.317 0 000 .633zm0 2.157h1.498a.317.317 0 000-.633H7.564a.317.317 0 000 .633zm.918-1.05h-.918a.317.317 0 010-.632h.918a.317.317 0 010 .633z"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <path d="M0 .75h16v16H0v-16z" fill="#fff" />
        </clipPath>
      </defs>
    </svg>
  );
};
